export default __webpack_public_path__ + "static/media/banner.ef7d3e5c.png";